import { normalizeHotelSearchFilters } from 'tripPlanner/api/hotelSearchFilters'
import type { IntlShape } from 'react-intl'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

export const formatChatLabel = (isoDate: string, intl: IntlShape): string => {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) {
    return isoDate
  }

  return intlDateFormatter(date, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }, intl.locale)
}

export function formatHotelSearchFiltersContext(filters: App.OfferListFilters): string {
  const selection = normalizeHotelSearchFilters(filters)
  return [
    selection.customerRatingGte && `Rating minimum: ${selection.customerRatingGte}`,
    selection.inclusions?.length && `Inclusions: ${selection.inclusions.join(', ')}`,
    selection.amenities?.length && `Amenities: ${selection.amenities.join(', ')}`,
  ].filter(Boolean).join('; ')
}
